// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../utils/i18n';

const getCurrentCurrency = () => {
  const currency = localStorage.getItem('currentCurrency');
  if (currency) return currency;
  return window.config.defaultCurrency;
};

export interface ConfigReducer {
  topMenuHeight: any;
  pageType: any;
  pageCode: any;
  resizeCounter: any;
  pageClassName: any;
  showGlobalWidgets: any;
  language: any;
  promotions: any;
  eligibleBonuses: any;
  availableBonuses: any;
  retailBonuses: any;
  preEuroTickets: any;
  lastProductId: any;
  bonusClaimError: any;
  loadingClaimBonus: any;
  eventLog: any;
  routerHistory: {
    pages: any;
    currentPath: any;
    pagesHistory: any;
  };
  inGameHeaderSelection: any;
}

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: <ConfigReducer>{
    topMenuHeight: null,
    pageType: null,
    pageCode: null,
    resizeCounter: 0,
    pageClassName: '',
    showGlobalWidgets: false,
    language: i18n.language ?? false,
    promotions: [],
    eligibleBonuses: null,
    availableBonuses: null,
    retailBonuses: null,
    preEuroTickets: 0,
    lastProductId: false,
    bonusClaimError: null,
    loadingClaimBonus: false,
    eventLog: [],
    routerHistory: {
      pages: -1,
      currentPath: '',
      pagesHistory: [],
    },
    inGameHeaderSelection: '',
  },
  reducers: {
    login: (state, action) => {},
    logout: (state, action) => {},
    setRouterHistory: (state, action) => {
      state.routerHistory = action.payload;
    },
    changeAccountLanguage: (state, action) => {
      state.language = action.payload;
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
      // `i18n.changeLanguage` fires i18next's `languageChanged`, which mirrors the active
      // language into the `language` localStorage key (see src/utils/i18n.ts). i18next's own
      // `i18nextLng` cache stays authoritative — don't write `language` from here (it would
      // reintroduce the drift: this reducer isn't the only path that changes the language).
      i18n.changeLanguage(action.payload);
    },
  },
});

export const { login, logout, setRouterHistory, changeAccountLanguage, changeLanguage } = authenticationSlice.actions;

export default authenticationSlice.reducer;
